export default {"src":"/_next/static/media/button_cute.43591a0f.gif","height":21,"width":63,"blurWidth":0,"blurHeight":0};